export default "__VITE_ASSET__BFjDZq7m__"